import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const home_page = createAsyncThunk(
  // [欢迎页奖励列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=179491129
  'Saada/KingKong/live/account/function_area',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/account/function_area', arg, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  home?: {
    list?: {
      id: number // 入口唯一标识ID
      text: string // 入口文字名称
      icon: string // 图标链接
      url: string // 跳转地址/标识
      badge?: string // 角标文字（如NEW/Hot，非必现）
      badge_id?: string // 角标唯一标识（用于埋点/控制显隐，非必现）
      is_need_set_password: boolean // 是否需要设置密码
      is_need_upgrade_password: boolean // 是否需要升级密码
      num: number // 数字角标数量（无则为0）
      task_tab: number // 任务标签标识/类型（无则为0）
    }[]
  }
}

const initialState: InitialStateType = {
  home: {
    list: [],
  },
}

export const SaadaKingKongSlice = createSlice({
  name: 'SaadaKingKong',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(home_page.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
  },
})
export default SaadaKingKongSlice.reducer
export const SaadaKingKongActions = SaadaKingKongSlice.actions

export const useSaadaKingKongState = () => {
  const data = useSelector((state) => {
    return state.SaadaKingKong
  })
  return data
}
